export interface ClientDto {
  id: string;
  name: string;
  name_EN: string;
  description: string;
  description_EN: string;
  redirectUri: string;
  logoutUri: string;
  logoUrl: string;
  isLocal: boolean;
  permissionPrefix: string;
  orderIndex: number;
  /** ClientCategory Id'si; kategorisiz bir API sürümü hiç göndermez. */
  clientCategoryId?: number;
}

/** Kategoriler artik tabloda; ikon anahtari ve adlar API'den gelir. */
export interface ClientCategoryDto {
  id: number;
  name: string;
  name_EN: string;
  icon: string;
  orderIndex: number;
  isActive: boolean;
  /** Kategoriye bagli silinmemis portal sayisi; pasife alma onayinda gosterilir. */
  clientCount: number;
}

export interface SaveClientCategoryDto {
  id?: number;
  name: string;
  name_EN: string;
  icon: string;
  orderIndex: number;
}

/** Bir portal kartinin kullanici bazli gorunumu. Sunucu yalnizca oturum sahibinin
 *  satirlarini dondurur ve yazar. */
export interface ClientUserPreferenceDto {
  clientId: string;
  /** Palet anahtari; null ise kart varsayilan zeminde kalir. */
  colorKey: string | null;
  /** Kullanicinin kendi sirasi; sadece renk verip siralamaya dokunmayanlarda null. */
  orderIndex: number | null;
}

export interface SaveClientUserPreferencesDto {
  items: ClientUserPreferenceDto[];
}

export enum ActionModeEnum {
  details = 1,
  edit = 2,
  create = 3,
}
